export default __webpack_public_path__ + "static/cp-website-mobile-869768a82cdf54ad74529c50358dbb08.jpg";